'use client';

import { useBookingCta } from './useBookingCta';

/**
 * The "Talk to us" form of `useBookingCta`: record the click as `talk-to-us`
 * at `location`, then open the booking modal. Components take an `onTalkToUs`
 * prop for reuse and fall back to this when none is given.
 */
export function useTalkToUs(location: string, override?: () => void): () => void {
  return useBookingCta('talk-to-us', location, override);
}
